import { forwardRef } from "react";
import VenueActivity from "./VenueActivity";
import VenueDetails from "./VenueDetails";
import VenueIcons from "./VenueIcons";
import VenueLocation from "./VenueLocation";
import VenueName from "./VenueName";
import VenuePricing from "./VenuePricing";
import VenueSlider from "./VenueSlider";

const VenueCard = forwardRef(
	({ children, onClick = () => {}, className = "" }, ref) => {
		return (
			<div
				className={`bg-white rounded-lg shadow-lg cursor-pointer overflow-hidden flex flex-col min-h-[480px] max-h-[520px] relative ${className}`}
				ref={ref}
				onClick={onClick}
			>
				{children}
			</div>
		);
	}
);

VenueCard.Slider = VenueSlider;
VenueCard.VenueName = VenueName;
VenueCard.Location = VenueLocation;
VenueCard.Icons = VenueIcons;
VenueCard.Activity = VenueActivity;
VenueCard.Details = VenueDetails;
VenueCard.Pricing = VenuePricing;

export default VenueCard;
